import { FC, ReactNode } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import './styleProvider.scss';

const StyleProvider: FC<StyleProviderProps> = (props: StyleProviderProps) => {
    const theme = createTheme({
        typography: {
            button: {
                textTransform: 'none',
                fontSize: '0.813rem'
            }
        },
        components: {
            MuiTypography: {
                defaultProps: {
                    fontFamily: 'Inter',
                    fontSize: 16
                }
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        textTransform: 'none',
                        fontSize: '0.813rem'
                    }
                }
            },
            MuiInputBase: {
                styleOverrides: {
                    root: {
                        color: 'white',
                        '&:has(> input:-webkit-autofill)': {
                            transitionDelay: '9999999999s',
                            transitionProperty: 'background-color, color',
                            '-webkit-box-shadow': '0 0 0 100px transparent inset',
                            '-webkit-text-fill-color': 'white'
                        }
                    }
                }
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    input: {
                        '&:-webkit-autofill': {
                            transitionDelay: '9999999999s',
                            transitionProperty: 'background-color, color',
                            '-webkit-box-shadow': '0 0 0 100px transparent inset',
                            '-webkit-text-fill-color': 'white'
                        }
                    }
                }
            }
        },
        palette: {
            primary: {
                main: '#479AEB',
                light: 'rgba(71, 154, 235, 1)',
                dark: 'rgba(241, 96, 93, 1)',
                contrastText: '#fff'
            },
            error: {
                main: 'rgba(241, 96, 93, 1)',
                light: 'rgba(241, 96, 93, 1)',
                dark: 'rgba(241, 96, 93, 1)'
            }
        }
    });
    return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
};

interface StyleProviderProps {
    children: ReactNode;
}

export default StyleProvider;
